module.exports = {
  /* eslint-disable */
  githubSrc: 'https://raw.githubusercontent.com/repronim/nimh-minimal/main/nimh_minimal/nimh_minimal_schema',
  banner: 'NIMH data collection',
  startButton: 'Start',
  assetsPublicPath: '/nimh-minimal/',
  backendServer: null
};
